import type {CareCard, GroupConfig} from '../types';

/** Shared "Real care, when you need it" cards. A site renders these until it sets its own `careCards`. */
export const DEFAULT_CARE_CARDS: CareCard[] = [
  {
    icon: 'video',
    color: '#2563eb',
    title: '$0 Copay Virtual Care',
    body: '24/7 virtual urgent care via the Clever app — cold, flu, allergy, eye/ear/mouth, injuries, refills.',
  },
  {
    icon: 'pill',
    color: '#7c3aed',
    title: 'Prescriptions',
    body: 'Unlimited ACA preventive prescriptions at $0 copay. Formulary medications also $0 copay, unlimited — call the Concierge Team at {phone} for the full list.',
  },
  {
    icon: 'stethoscope',
    color: '#16a34a',
    title: 'Physician Office Visits',
    body: 'Primary care, specialist, and urgent-care visits with $25–$75 copays at FirstHealth PPO providers; visit limits apply.',
  },
  {
    icon: 'flask-conical',
    color: '#dc2626',
    title: 'Lab Tests + Imaging',
    body: 'Diagnostic, lab, and x-ray benefits on Bronze and above — Class I, II, and III tiering with per-day allowances.',
  },
];

export function siteCareCards(group: GroupConfig): CareCard[] {
  return group.careCards ?? DEFAULT_CARE_CARDS;
}
